<div class="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
    <div class="container mx-auto px-4 py-8">
        <div class="mb-8">
            <div class="flex items-center mb-4">
                <div class="bg-gradient-to-r from-purple-500 to-indigo-600 p-3 rounded-xl shadow-lg mr-4">
                    <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z">
                        </path>
                    </svg>
                </div>
                <div>
                    <h1
                        class="text-4xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
                        Reporte Consolidado Wompi
                    </h1>
                    <p class="text-gray-600 mt-1">Genera reporte detallado cruzando transacciones con el sistema</p>
                </div>
            </div>
        </div>

        <div class="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
            <div class="bg-gradient-to-r from-purple-50 to-indigo-50 border-b border-gray-100 p-6">
                <h2 class="text-xl font-semibold text-gray-800 flex items-center">
                    <svg class="w-5 h-5 mr-2 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z">
                        </path>
                    </svg>
                    Configuración del Reporte
                </h2>
                <p class="text-gray-600 text-sm mt-1">Seleccione el rango de fechas</p>
            </div>

            <div class="p-6">
                <form [formGroup]="reportForm" (ngSubmit)="downloadExcelReport()">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8 max-w-4xl">

                        <!-- Selector de Fecha Inicio -->
                        <div class="space-y-2">
                            <label for="startDate" class="block text-sm font-semibold text-gray-700 flex items-center">
                                <svg class="w-4 h-4 mr-1 text-indigo-600" fill="none" stroke="currentColor"
                                    viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z">
                                    </path>
                                </svg>
                                Fecha Inicio *
                            </label>
                            <p-calendar formControlName="startDate" [showIcon]="true" inputId="startDate"
                                dateFormat="dd/mm/yy" [iconDisplay]="'input'" styleClass="w-full"
                                inputStyleClass="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 placeholder-gray-500 shadow-sm transition-all duration-200 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20"
                                [appendTo]="'body'" (onSelect)="onStartDateChange($event)"></p-calendar>
                        </div>

                        <!-- Selector de Fecha Fin -->
                        <div class="space-y-2">
                            <label for="endDate" class="block text-sm font-semibold text-gray-700 flex items-center">
                                <svg class="w-4 h-4 mr-1 text-indigo-600" fill="none" stroke="currentColor"
                                    viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z">
                                    </path>
                                </svg>
                                Fecha Fin *
                            </label>
                            <p-calendar formControlName="endDate" [showIcon]="true" inputId="endDate"
                                dateFormat="dd/mm/yy" styleClass="w-full" [iconDisplay]="'input'" [appendTo]="'body'"
                                inputStyleClass="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 placeholder-gray-500 shadow-sm transition-all duration-200 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20"
                                (onSelect)="onEndDateChange($event)"></p-calendar>
                        </div>
                    </div>

                    <div class="bg-gray-50 rounded-lg p-4 mb-6 max-w-4xl">
                        <h3 class="text-lg font-semibold text-gray-800 mb-2">Selección Actual:</h3>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                            <div>
                                <span class="font-medium text-gray-600">Período:</span>
                                <span class="ml-2 text-gray-800">{{ reportForm.value.startDate | date:'dd/MM/yy' }} - {{
                                    reportForm.value.endDate | date:'dd/MM/yy' }}</span>
                            </div>
                            <div>
                                <span class="font-medium text-gray-600">Tipo:</span>
                                <span class="ml-2 text-indigo-600 font-medium">Consolidado con Cruce de Sistema</span>
                            </div>
                        </div>
                    </div>

                    <div class="flex flex-col sm:flex-row justify-end gap-4 max-w-4xl">
                        <button type="submit" [disabled]="!startDate || !endDate || loading"
                            class="px-8 py-3 bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-semibold rounded-xl shadow-lg hover:from-purple-700 hover:to-indigo-700 transform hover:scale-105 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center min-w-[200px]">

                            <div *ngIf="loading" class="flex items-center">
                                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-3"></div>
                                <span>Generando Excel...</span>
                            </div>

                            <div *ngIf="!loading" class="flex items-center">
                                <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M12 10v6m0 0l-3-3m3 3l3-3M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z">
                                    </path>
                                </svg>
                                <span>Descargar Excel Consolidado</span>
                            </div>
                        </button>
                    </div>
                </form>
            </div>
        </div>

        <!-- My Reports Section -->
        <app-recent-report-jobs></app-recent-report-jobs>

        <div class="mt-8 bg-white rounded-xl shadow-sm border border-gray-100 p-6">
            <div class="flex items-start">
                <div class="flex-shrink-0">
                    <svg class="w-6 h-6 text-blue-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                </div>
                <div class="ml-4">
                    <h4 class="text-lg font-medium text-gray-800">Información del Reporte</h4>
                    <div class="mt-2 text-sm text-gray-600 space-y-1">
                        <p>• El reporte genera un archivo Excel con dos hojas:</p>
                        <ul class="list-disc ml-5 mt-1 mb-2">
                            <li><b>Con Link Sistema:</b> Transacciones que se pudieron cruzar con un Link de Pago
                                (Muestra Estudiante, Proyecto, etc.)</li>
                            <li><b>Sin Link Sistema:</b> Transacciones huérfanas o sin identificador de link asociado.
                            </li>
                        </ul>
                        <p>• El campo "Conciliado" indica si la transacción ya cruzó contra un reporte de Plink.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>